// Роуты модуля СКУД. Один набор path'ов, разные компоненты-обёртки под роли admin/client.
// Spread'ятся в children '/admin' и '/client' в src/router.js ПЕРЕД catch-all ':entity/list'.

export const router_skud_admin = [
  {
    path: 'skud/card/list',
    name: 'SkudCardListAdmin',
    component: () => import('@/views/admin/skud/Card-list')
  },
  {
    path: 'skud/passage/list',
    name: 'SkudPassageListAdmin',
    component: () => import('@/views/admin/skud/Passage-list')
  },
  {
    path: 'skud/report',
    name: 'SkudReportAdmin',
    component: () => import('@/views/admin/skud/Report-page')
  },
  {
    path: 'skud/guest/list',
    name: 'SkudGuestListAdmin',
    component: () => import('@/views/admin/skud/Guest-list')
  },
  {
    path: 'skud/guest/view',
    name: 'SkudGuestViewAdmin',
    component: () => import('@/views/admin/skud/Guest-page')
  },
  {
    path: 'skud/visit/list',
    name: 'SkudVisitListAdmin',
    component: () => import('@/views/admin/skud/Visit-list')
  },
  {
    path: 'skud/visit/create',
    name: 'SkudVisitCreateAdmin',
    component: () => import('@/views/admin/skud/Visit-page')
  },
  {
    path: 'skud/visit/view',
    name: 'SkudVisitViewAdmin',
    component: () => import('@/views/admin/skud/Visit-page')
  },
  {
    path: 'skud/audit/list',
    name: 'SkudAuditListAdmin',
    component: () => import('@/views/admin/skud/Audit-list')
  },
  {
    path: 'skud/token/list',
    name: 'SkudConsumerTokenListAdmin',
    component: () => import('@/views/admin/skud/ConsumerToken-list')
  },
  {
    path: 'skud/brsk',
    name: 'SkudBrskAdmin',
    component: () => import('@/views/admin/skud/Brsk-page')
  },
  {
    path: 'skud/command',
    name: 'SkudCommandAdmin',
    component: () => import('@/views/admin/skud/Command-page')
  },
  {
    path: 'skud/point/list',
    name: 'SkudPointListAdmin',
    component: () => import('@/views/admin/skud/Point-list')
  }
]

export const router_skud_client = [
  {
    path: 'skud/card/list',
    name: 'SkudCardListClient',
    component: () => import('@/views/client/skud/Card-list')
  },
  {
    path: 'skud/passage/list',
    name: 'SkudPassageListClient',
    component: () => import('@/views/client/skud/Passage-list')
  },
  {
    path: 'skud/report',
    name: 'SkudReportClient',
    component: () => import('@/views/client/skud/Report-page')
  },
  {
    path: 'skud/guest/list',
    name: 'SkudGuestListClient',
    component: () => import('@/views/client/skud/Guest-list')
  },
  {
    path: 'skud/guest/view',
    name: 'SkudGuestViewClient',
    component: () => import('@/views/client/skud/Guest-page')
  },
  {
    path: 'skud/visit/list',
    name: 'SkudVisitListClient',
    component: () => import('@/views/client/skud/Visit-list')
  },
  {
    path: 'skud/visit/create',
    name: 'SkudVisitCreateClient',
    component: () => import('@/views/client/skud/Visit-page')
  },
  {
    path: 'skud/visit/view',
    name: 'SkudVisitViewClient',
    component: () => import('@/views/client/skud/Visit-page')
  },
  {
    path: 'skud/command',
    name: 'SkudCommandClient',
    component: () => import('@/views/client/skud/Command-page')
  }
]
